import React from "react";
import { observer } from "mobx-react";
import { IconButton } from "@material-ui/core";

import { useStore } from "../../store";
import { Icon, HeaderBackButton } from "../../components";

const DetailHeader = () => {
  const {
    detailStore: {
      onRevertDetailState,
      infoState: { isMoreInfo },
      onResetInfoState,
      downloadState: { isDownload },
      onDownloadCancel,
      errorState: { status, errorCode },
      onResetErrorState,
    },
  } = useStore();

  const MoreButton = () => (
    <IconButton onClick={onResetInfoState} style={{ marginRight: "auto" }}>
      <Icon name="arrowDown" size={28} />
    </IconButton>
  );

  const isOnClick = isDownload || status || errorCode ? true : false;
  const onClick = () => {
    if (isDownload) return onDownloadCancel();
    if (status || errorCode) return onResetErrorState();
  };

  if (isMoreInfo) return <MoreButton />;
  return (
    <HeaderBackButton
      onClick={isOnClick ? onClick : undefined}
      onBackCallback={onRevertDetailState}
    />
  );
};

export default observer(DetailHeader);
